import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { automationsRoutes } from './automations.routing';
import { AutomationsSettingsComponent } from './automations.component';
import { AutomationsSettingsListComponent } from './list/list.component';
import { AutomationDetailsComponent } from './details/details.component';
import { AutomationTriggersModule } from './libraries/triggers/triggers.module';
import { AutomationActionsModule } from './libraries/actions/actions.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BuilderComponent } from './builder/builder.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { SharedModule } from 'app/shared/shared.module';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { BasicSetupCardComponent } from './builder/@components/cards/basic-setup/basic-setup.component';
import { BasicSetupFormComponent } from './builder/@components/forms/basic-setup/basic-setup.component';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { ActionSetupCardComponent } from './builder/@components/cards/action-setup/action-setup.component';
import { TriggersSetupCardComponent } from './builder/@components/cards/triggers-setup/triggers-setup.component';
import { ActionSetupFormComponent } from './builder/@components/forms/action-setup/action-setup.component';
import { TriggersSetupFormComponent } from './builder/@components/forms/triggers-setup/triggers-setup.component';
import { AutomationBuilderFormSetupComponent } from './builder/@components/forms/form-setup/form-setup.component';
import { OverlayHelperComponent } from 'app/shared/components/overlay-helper/overlay-helper.component';

@NgModule({
  declarations: [
    AutomationsSettingsComponent,
    AutomationsSettingsListComponent,
    AutomationDetailsComponent,
    BuilderComponent,
    BasicSetupCardComponent,
    BasicSetupFormComponent,
    ActionSetupFormComponent,
    ActionSetupCardComponent,
    TriggersSetupCardComponent,
    TriggersSetupFormComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(automationsRoutes),
    FormsModule,
    MatTableModule,
    MatRadioModule,
    MatIconModule,
    MatButtonModule,
    MatSortModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatDialogModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressBarModule,
    AutomationTriggersModule,
    AutomationActionsModule,
    OverlayModule,
    SharedModule,
    MatSelectModule,
    OverlayHelperComponent,
    AutomationBuilderFormSetupComponent,
  ],
})
export class AutomationsModule {}
